import { render } from "./FooterLinkList.vue?vue&type=template&id=0df46cf2"
import script from "./FooterLinkList.vue?vue&type=script&lang=js"
export * from "./FooterLinkList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__